import React from "react";
import { useModal } from "../_contexts";
import { Icon } from "../_components";
import ReactTooltip from "react-tooltip";

export function ChronicleToolbar() {
  const { openModal } = useModal();
  const handleMapManager = (ev) => {
    openModal("mapManager");
  };
  const handleTimelineManager = (ev) => {
    openModal("timelineManager");
  };
  const handleImageManager = (ev) => {
    openModal("imageManager");
  };
  const handleMarkerTemplatesManager = () => {
    openModal("markerTemplateManager");
  };
  const handleHelpModal = (ev) => {
    openModal("help");
  };
  const handleChronicleManager = (ev) => {
    // console.log('Not yet implemented!');
    openModal("chronicleSettings");
  };
  const handleEventManager = (ev) => {
    openModal("eventManager");
  };
  const handleCalendarManager = (ev) => {
    openModal("calendarManager");
  };
  return (
    <div
      className="chronos-chronicle-toolbar"
      style={{ boxShadow: "rgba(0,0,0,0.65) 0px 1px 5px 0px" }}
    >
      {/* Map Manager */}
      <ToolbarButton
        icon="far fa-map fa-fw"
        click={handleMapManager}
        tip="Maps Manager"
      />
      {/* Timeline Manager */}
      <ToolbarButton
        icon="far fa-stream fa-fw"
        click={handleTimelineManager}
        tip="Timelines Manager"
      />
      {/* Event Manager */}
      <ToolbarButton
        icon="far fa-sparkles fa-fw"
        click={handleEventManager}
        tip="Events Manager"
      />
      {/* Image Manager */}
      <ToolbarButton
        icon="far fa-images fa-fw"
        click={handleImageManager}
        tip="Images Manager"
      />
      {/* Marker Templates Manager */}
      {/* DISABLED in favor of future release */}
      {/* <ToolbarButton
        icon="far fa-map-marker-edit fa-fw"
        click={handleMarkerTemplatesManager}
        tip="Open Marker Templates"
      /> */}
      {/* Calendar Manager */}
      <ToolbarButton
        icon="far fa-calendar-edit fa-fw"
        click={handleCalendarManager}
        tip="Calendars Manager"
      />

      {/* Documentation */}
      <ToolbarButton
        icon="far fa-book fa-fw"
        click={handleHelpModal}
        tip="Help & Documentation"
      />

      {/* Chronicle Manager */}
      <ToolbarButton
        icon="far fa-cogs fa-fw"
        click={handleChronicleManager}
        tip="Chronicle Settings"
      />
    </div>
  );
}

function ToolbarButton({ icon, tip, click }) {
  return (
    <div
      className="chronicle-toolbar-button"
      data-tip={tip}
      data-for="chronicle-toolbar"
      onClick={click}
    >
      <Icon icon={icon} />
      <ReactTooltip effect="solid" id="chronicle-toolbar" />
    </div>
  );
}
